'use client'
import{a as i,c as t}from"./chunk-4K73N3NP.mjs";import{cn as u}from"@sajilni/utils/cn";import{jsx as m}from"react/jsx-runtime";function d(o){var e=o,{className:n}=e,r=t(e,["className"]);return m("div",i({className:u("ui-bg-primary/10 ui-animate-pulse ui-rounded-md",n)},r))}export{d as a};
